import { StoreSettingsFormValues } from './generalTheme.types';

export const defaultStoreSettings: StoreSettingsFormValues = {
  productsQuantityFormat: {
    milSeparator: ',',
    fractionalSeparator: '.',
    thousandShorthand: false,
    millionShorthand: false,
    billionShorthand: false,
    trillionShorthand: false,
    quadrillionShorthand: false,
    quintillionShorthand: false,
    digitsBasedAbbreviation: false,
    maxDigitsWithoutShorthand: 3
  },
  balanceQuantityFormat: {
    milSeparator: ',',
    fractionalSeparator: '.',
    thousandShorthand: false,
    millionShorthand: false,
    billionShorthand: false,
    trillionShorthand: false,
    quadrillionShorthand: false,
    quintillionShorthand: false,
    digitsBasedAbbreviation: false,
    maxDigitsWithoutShorthand: 3
  },
  specialOfferQuantityFormat: {
    milSeparator: ',',
    fractionalSeparator: '.',
    thousandShorthand: false,
    millionShorthand: false,
    billionShorthand: false,
    trillionShorthand: false,
    quadrillionShorthand: false,
    quintillionShorthand: false,
    digitsBasedAbbreviation: false,
    maxDigitsWithoutShorthand: 3
  },
  rollingOfferQuantityFormat: {
    milSeparator: ',',
    fractionalSeparator: '.',
    thousandShorthand: false,
    millionShorthand: false,
    billionShorthand: false,
    trillionShorthand: false,
    quadrillionShorthand: false,
    quintillionShorthand: false,
    digitsBasedAbbreviation: false,
    maxDigitsWithoutShorthand: 3
  }
};
